<template>
  <v-card class="mx-auto" style="padding: 5%;">
    <v-form ref="form" v-model="form">
      <v-row>
        <v-col cols="12"> 1. {{ $t(`message.slideTwentyQuestionOne`) }} </v-col>
        <v-col :cols="yesNo">
          <v-radio-group v-model="technicalIssues" align="center" row>
            <v-radio
              :label="$t(`message.RadioGroupYesLabel`)"
              value="yes"
            ></v-radio>
            <v-radio
              :label="$t(`message.RadioGroupNoLabel`)"
              value="no"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col :cols="yesNoComment">
          <v-text-field
            outlined
            v-model="technicalIssuesComment"
            :hint="$t(`message.slideTwentyQuestionOneHint`)"
            :label="$t(`message.slideTwentyCommentLabel`)"
            style="min-height: 96px"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider><br />
      <v-row>
        <v-col cols="12"> 2. {{ $t(`message.slideTwentyQuestionTwo`) }} </v-col>
        <v-col cols="12">
          <v-slider
            v-model="easyToFollow"
            :tick-labels="sliderLabels"
            :max="4"
            step="1"
            ticks="always"
            tick-size="5"
          >
          </v-slider>
        </v-col>
      </v-row>
      <v-divider></v-divider><br />
      <v-row>
        <v-col cols="12">
          3. {{ $t(`message.slideTwentyQuestionThree`) }}
        </v-col>
        <v-col cols="12">
          <v-slider
            v-model="purposeMadeClearToMe"
            :tick-labels="sliderLabels"
            :max="4"
            step="1"
            ticks="always"
            tick-size="5"
          >
          </v-slider>
        </v-col>
      </v-row>
      <v-divider></v-divider><br />
      <v-row>
        <v-col cols="12">
          4. {{ $t(`message.slideTwentyQuestionFour`) }}
        </v-col>
        <v-col cols="5">
          <v-select
            outlined
            v-model="howDidYouHear"
            :items="$t(`message.slideTwentyQuestionFourSelectChoices`)"
            multiple
            :hint="$t(`message.slideTwentyQuestionFourSelectHint`)"
            persistent-hint
            item-text="label"
            item-value="value"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0">
                <span>{{ item.label }}</span>
              </v-chip>
              <span v-if="index === 1" class="text caption"
                >(+{{ howDidYouHear.length - 1 }} others)</span
              >
            </template>
          </v-select>
        </v-col>
        <v-col cols="7">
          <v-text-field
            outlined
            v-model="howDidYouHearComment"
            :hint="$t(`message.slideTwentyQuestionFourCommentHint`)"
            :label="$t(`message.slideTwentyCommentLabel`)"
            style="min-height: 96px"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider></v-divider><br />
      <v-row>
        <v-col cols="12">
          5. {{ $t(`message.slideTwentyQuestionFive`) }}
        </v-col>
        <v-col cols="12">
          <v-slider
            v-model="wasHelpful"
            :tick-labels="sliderLabels"
            :max="4"
            step="1"
            ticks="always"
            tick-size="5"
          >
          </v-slider>
        </v-col>
      </v-row>
      <v-divider></v-divider><br />
      <v-row>
        <v-col cols="12"> 6. {{ $t(`message.slideTwentyQuestionSix`) }} </v-col>
        <v-col :cols="yesNo">
          <v-radio-group v-model="suggestedImprovements" row>
            <v-radio
              :label="$t(`message.RadioGroupYesLabel`)"
              value="yes"
            ></v-radio>
            <v-radio
              :label="$t(`message.RadioGroupNoLabel`)"
              value="no"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col :cols="yesNoComment">
          <v-text-field
            outlined
            v-model="suggestedImprovementsComment"
            :hint="$t(`message.slideTwentyQuestionSixCommentHint`)"
            :label="$t(`message.slideTwentyCommentLabel`)"
            style="min-height: 96px"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-divider></v-divider>
    <v-alert type="success" v-if="finished">
      <b> {{ $t(`message.SuccessSubmit`) }} </b>
    </v-alert>
    <v-alert type="error" v-if="error">
      <b> {{ $t(`message.ErrorSubmit`) }} </b>
    </v-alert>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text :disabled="finished" @click="$refs.form.reset()">
        {{ $t(`message.ClearBtn`) }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed :disabled="finished" @click="submitResponse">{{
        $t(`message.submit`)
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "HowWasYourExperience",
  props: {
    toggleDialog: {
      type: Function
    },
    dialogBoolean: {
      type: Boolean
    }
  },
  data: () => ({
    technicalIssues: "",
    technicalIssuesComment: "",
    easyToFollow: 0,
    purposeMadeClearToMe: 0,
    sliderLabels: ["1", "2", "3", "4", "5"],
    howDidYouHear: [],
    howDidYouHearComment: "",
    wasHelpful: 0,
    suggestedImprovements: "",
    suggestedImprovementsComment: "",
    form: false,
    finished: false,
    error: false
  }),
  computed: {
    yesNo() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 2;
    },
    yesNoComment() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 10;
    }
  },
  methods: {
    ...mapActions({
      addResponse: "response/addResponse"
    }),
    submitResponse() {
      const formData = {
        technicalIssues: this.technicalIssues,
        technicalIssuesComment: this.technicalIssuesComment,
        easyToFollow: this.easyToFollow + 1, // starts at 0 so offset by 1
        purposeMadeClearToMe: this.purposeMadeClearToMe + 1, // starts at 0 so offset by 1
        howDidYouHear: this.howDidYouHear,
        howDidYouHearComment: this.howDidYouHearComment,
        wasHelpful: this.wasHelpful + 1, // starts at 0 so offset by 1
        suggestedImprovements: this.suggestedImprovements,
        suggestedImprovementsComment: this.suggestedImprovementsComment
      };
      const payload = {
        survey: 2, // How Was Your Experience
        survey_taker_id: 1, // anonymous user
        response_json: formData,
        comment_location: [],
        survey_metadata: 2 // How Was Your Experiencemetadata
      };
      this.addResponse(payload)
        .then(() => {
          this.finished = true;
          setTimeout(() => {
            this.finished = false;
            this.$refs.form.reset();
            if (this.dialogBoolean) {
              this.toggleDialog();
            }
          }, 5000);
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 5000);
        });
    }
  }
};
</script>
